// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__13kvf","inner":"Form_inner__eCYOy","range":"Form_range__2P304","name":"Form_name__36QDc","actions":"Form_actions__HGj02"};